import { Component } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[gbc-button]',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: true
})
export class ButtonComponent { }
